import React, { useState } from 'react'
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import http, { baseURLPublic } from '../../../config/BaseUrl';

const SMSModal = ({ sendSMS }) => {
    const [loading, setLoading] = useState(false)
    const [closeModal, setCloseModal] = useState("")
    const [isSuccess, setIsSuccess] = useState(false)
    const { register, handleSubmit, formState: { errors }, reset } = useForm({ mode: "all", reValidateMode: "onChange" })
    const handelSMSSend = async (data) => {
        const shareEmail = {
            event_id: sendSMS.event_id,
            media_id: sendSMS.media_id,
            sharing_platform: "sms",
            phone: data.send_sms,
            sms_share: "sms",
            share_datetime: new Date().getTime(),
        }

        setLoading(true)
        await baseURLPublic.post("share-gallery-count-email-sms", shareEmail).then((res) => {
            if (res) {
                setLoading(false)
                setCloseModal("none")
                reset()
                setIsSuccess(true)

                setTimeout(()=>{
                    setIsSuccess(false)
                }, 2000)
                return "success"
            }
        }).catch((err) => {
            setLoading(false)
        })
    }




    return (
        <div className="modal fade" id="socialShareSMS" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Send SMS</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <form onSubmit={handleSubmit(handelSMSSend)}>
                        <div className="modal-body my-5">
                            {!loading ? 
                            (
                                isSuccess ?
                                    <h3 className="text-center text-primary">Successfully shared</h3>
                                :
                                <>
                                    <input
                                        type="number"
                                        className={classNames("form-control", { "is-invalid": errors.send_sms })}
                                        placeholder="Enter a mobile number"
                                        {...register("send_sms", {
                                            required: "This field is required"
                                        })}
                                    />
                                    <small className="text-danger">{errors.send_sms && errors.send_sms.message}</small>
                                </>
                            )
                            : <h3 className="text-center text-primary">SMS Sharing...</h3>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn-primary">Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SMSModal
